module.exports = __webpack_public_path__ + "static/media/smartAsn-logos-bssn.984a6bc2.svg";